'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrganizingCommitteeForm = function (_React$Component) {
	_inherits(OrganizingCommitteeForm, _React$Component);

	function OrganizingCommitteeForm(props) {
		_classCallCheck(this, OrganizingCommitteeForm);

		var _this = _possibleConstructorReturn(this, (OrganizingCommitteeForm.__proto__ || Object.getPrototypeOf(OrganizingCommitteeForm)).call(this, props));

		_this.onNameChange = _this.onNameChange.bind(_this);
		_this.cancel = _this.cancel.bind(_this);
		_this.onClickSubmit = _this.onClickSubmit.bind(_this);
		return _this;
	}

	_createClass(OrganizingCommitteeForm, [{
		key: 'componentWillMount',
		value: function componentWillMount() {

			var initialState = {
				nameErrorMsg: '',
				organizingCommitteeErrorMsg: ''
			};

			if (typeof this.props.organizingCommittee !== 'undefined') {
				initialState.organizingCommittee = this.props.organizingCommittee;
			} else {
				initialState.organizingCommittee = {
					name: ''
				};
			}

			this.setState(initialState);
		}
	}, {
		key: 'onClickSubmit',
		value: function onClickSubmit() {
			this.props.submit(this.state.organizingCommittee);
		}
	}, {
		key: 'onNameChange',
		value: function onNameChange(event, value) {
			this.setState({
				organizingCommittee: _extends({}, this.state.organizingCommittee, {
					name: value
				})
			});
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			this.props.cancel();
		}
	}, {
		key: 'render',
		value: function render() {
			var requestingCreateOrganizingCommittee = this.props.requestingCreateOrganizingCommittee;
			var _state = this.state,
			    organizingCommittee = _state.organizingCommittee,
			    nameErrorMsg = _state.nameErrorMsg;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_TextField2.default, {
						hintText: 'Nome',
						floatingLabelText: 'Nome',
						floatingLabelFixed: true,
						onChange: this.onNameChange,
						value: organizingCommittee.name,
						errorText: nameErrorMsg,
						fullWidth: true
					})
				),
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_RaisedButton2.default, { label: 'Cancelar', onClick: this.cancel }),
					_react2.default.createElement(_RaisedButton2.default, {
						primary: true, label: 'Enviar',
						onClick: this.onClickSubmit,
						style: { marginLeft: '1rem' }
					}),
					requestingCreateOrganizingCommittee && _react2.default.createElement(_CircularProgress2.default, null)
				)
			);
		}
	}]);

	return OrganizingCommitteeForm;
}(_react2.default.Component);

exports.default = OrganizingCommitteeForm;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/organizingCommittees/organizingCommitteesForm.js
// module id = 1314
// module chunks = 0